import React from "react";
import { Box, Container, Grid } from "@mui/material";

function Stories() {
    return (
        <>
            <Box className="storiesBox lightGrayBox">
                <Container maxWidth="md">
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid size={12}>
                            <Box className="templeInnerHeading">
                                <h2>Mysteries and Marvels of Temples</h2>
                            </Box>
                        </Grid>
                        <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <Box className="storeisImg">
                                <img src="/assets/stories-img.svg" alt="" className="img-fluid" />
                            </Box>
                        </Grid>
                        <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <Box className="storeisContent">
                                <img src="/assets/quotes.svg" className="img-fluid" alt="" />
                                <h3>KEDARNATH</h3>
                                <p>It is believed to be one of the <span>12 Jyotirlingas</span>, and its history and construction remain shrouded in some mystery, with legends connecting it to the Pandavas.</p> 
                                <p>The temple's unique architecture and its survival during the 2013 floods add to its mystique. </p>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
}

export default Stories;